const DATA = [
  {
    tab: 'Domestic',
    data: [
      {
        title: 'Construction & Engineering Litigation',
        content:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      },
      {
        title: 'Real Estate Development & Real Estate Financing',
        content:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      },
      {
        title: 'Issuance of Securities',
        content:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      },
      {
        title: 'Listing',
        content:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      },
      {
        title: 'Outbound investments and M&A',
        content:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      },
    ],
  },
  {
    tab: 'Overseas',
    data: [
      {
        title: 'Entering Southeast Asian Market',
        content: [
          'Advised on overseas investment for Korean corporate clients, such as, KB Kookmin Bank, Shinhan Bank, JB Bank, LS Cable, Samsung Electronics, POSCO E&C, LS Builwin, Bohmin E&C, and Korean Air',
          'Advised on day to day operation for Japanese clients (Mitsui) and Korean clients, such as, LG Trading, AJU Industry, LS Cable',
          'Advised on developing transactions structures of assigning shares and conducting legal due diligence for local sewing company',
        ],
      },
      {
        title: 'Investment. Joint venture projects',
        content: [
          'Advised on overseas investment for Korean corporate clients, such as, KB Kookmin Bank, Shinhan Bank, JB Bank, LS Cable, Samsung Electronics, POSCO E&C, LS Builwin, Bohmin E&C, and Korean Air',
          'Advised on day to day operation for Japanese clients (Mitsui) and Korean clients, such as, LG Trading, AJU Industry, LS Cable',
          'Advised on developing transactions structures of assigning shares and conducting legal due diligence for local sewing company',
        ],
      },
      {
        title: 'Finance. Asset Management',
        content: [
          'Advised on overseas investment for Korean corporate clients, such as, KB Kookmin Bank, Shinhan Bank, JB Bank, LS Cable, Samsung Electronics, POSCO E&C, LS Builwin, Bohmin E&C, and Korean Air',
          'Advised on day to day operation for Japanese clients (Mitsui) and Korean clients, such as, LG Trading, AJU Industry, LS Cable',
          'Advised on developing transactions structures of assigning shares and conducting legal due diligence for local sewing company',
        ],
      },
      {
        title: 'Real Estate. PF',
        content: [
          'Advised on overseas investment for Korean corporate clients, such as, KB Kookmin Bank, Shinhan Bank, JB Bank, LS Cable, Samsung Electronics, POSCO E&C, LS Builwin, Bohmin E&C, and Korean Air',
          'Advised on day to day operation for Japanese clients (Mitsui) and Korean clients, such as, LG Trading, AJU Industry, LS Cable',
          'Advised on developing transactions structures of assigning shares and conducting legal due diligence for local sewing company',
        ],
      },
      {
        title: 'Others',
        content: [
          'Advised on overseas investment for Korean corporate clients, such as, KB Kookmin Bank, Shinhan Bank, JB Bank, LS Cable, Samsung Electronics, POSCO E&C, LS Builwin, Bohmin E&C, and Korean Air',
          'Advised on day to day operation for Japanese clients (Mitsui) and Korean clients, such as, LG Trading, AJU Industry, LS Cable',
          'Advised on developing transactions structures of assigning shares and conducting legal due diligence for local sewing company',
        ],
      },
    ],
  },
]

export default DATA
